import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuardService} from '../../core/auth';

import {AdminComponent} from './admin.component';

import {UserListPage} from '../user/pages/user-list/user-list.page';
import {NotificationListComponent} from './notifications/notification-list/notification-list.component';
import {UserCreationPage, UserDetailsPage} from '../user/pages';
import {UserGroupDCreationPage, UserGroupDetailsPage, UserGroupListPage} from '../user-group/pages';
import {ConfigurationListPage} from '../configuration/pages';
import {CustomerListPage} from '../customer/pages/customer-list/customer-list.page';
import {CustomerDetailsPage} from '../customer/pages/customer-details/customer-details.page';
import {UserDetailsEditComponent} from '../user/components';


const routes: Routes = [
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    children: [
      {
        path: 'customer/list', component: CustomerListPage,
        data: {title: 'Customer Overview', roles: ['AC_MANAGE_CUSTOMER', 'AC_READ_CUSTOMER']}
      },
      {
        path: 'customer/:id', component: CustomerDetailsPage,
        data: {title: 'Customer Detail', roles: ['AC_MANAGE_CUSTOMER', 'AC_READ_CUSTOMER']}
      },
      {
        path: 'user', component: UserCreationPage,
        data: {title: 'User', roles: ['AC_MANAGE_USER']}
      },
      {
        path: 'user/list', component: UserListPage,
        data: {title: 'User Overview', roles: ['AC_MANAGE_USER', 'AC_READ_USER']}
      },
      {
        path: 'user/:id', component: UserDetailsPage,
        data: {title: 'User Detail', roles: ['AC_MANAGE_USER', 'AC_READ_USER']}
      },
      {
        path: 'user/:id/edit', component: UserDetailsEditComponent,
        data: {title: 'User Edit', roles: ['AC_MANAGE_USER', 'AC_READ_USER']}
      },
      {
        path: 'group', component: UserGroupDCreationPage,
        data: {title: 'Group', roles: ['AC_MANAGE_GROUP']}
      },
      {
        path: 'group/list', component: UserGroupListPage,
        data: {title: 'Group Overview', roles: ['AC_MANAGE_GROUP', 'AC_READ_GROUP']}
      },
      {
        path: 'group/:id', component: UserGroupDetailsPage,
        data: {title: 'Group Detail', roles: ['AC_MANAGE_GROUP', 'AC_READ_GROUP']}
      },
      {
        path: 'configuration', component: ConfigurationListPage,
        data: {title: 'Configuration', roles: ['AC_MANAGE_CONFIGURATION', 'AC_READ_CONFIGURATION']}
      },
      {
        path: 'notifications', component: NotificationListComponent,
        data: {title: 'Notifications', roles: ['AC_MANAGE_NOTIFICATION', 'AC_READ_NOTIFICATION']}
      }
    ]

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {
}
